import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import setupLocatorUI from "@locator/runtime";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}



createRoot(document.getElementById('root')).render(

    <BrowserRouter>
    
      <App />
    </BrowserRouter>

)